import { OrderFilterBase } from "./orderFilterBase";
import { ColumnInfoBase } from "./columnInfoBase";

export class SearchFilterBase {
    public pageNumber?: number;
    public pageSize?: number;
    public returnTotalCount?: boolean;
    public text: string;

    public order: OrderFilterBase;
    public columnInfo: ColumnInfoBase;
}

